const forbiddenNames = [
  'Test User',
  'Fake Name',
  'John Doe',
  'Jane Doe',
  'Admin User',
  'QA Test',
  'Unit Test',
  'Automation Bot',
  'Sample User',
  'Demo Account',
  'Foo Bar',
  'Bar Baz',
  'Null Null',
  'Firstname Lastname',
  'No Name',
  'Test Account',
  'Testing User',
  'Fake Person',
  'Anonymous User',
  'Guest Account',
  'N/A',
  'None',
  'Mr Test',
  'Ms Test',
  'Test Tester',
  'Test Person',
  'Demo User',
  'Demo Customer',
  'Example User',
  'Example Person',
  'Example Name',
  'Default User',
  'Test Data',
  'Sample Account',
  'Fake Customer',
  'Dummy Name',
  'Dummy User',
  'Placeholder Name',
  'Fakey McFakeface',
  'John Smith',
  'Jane Smith',
  'Mickey Mouse',
  'Donald Duck',
  'Bugs Bunny',
  'Elmer Fudd',
  'Homer Simpson',
  'Bart Simpson',
  'Lisa Simpson',
  'Marge Simpson',
  'Test1 User',
  'Test2 User',
  'Test123',
  'User123',
  'Tester One',
  'Tester Two',
  'QA Bot',
  'Staging User',
  'Sandbox User',
  'Fake Tester',
  'Invalid Name',
  'Not Real',
  'Nobody',
  'Nothing',
  'Test Dummy',
  'Unit Tester',
  'Automation Test',
  'Load Test',
  'Stress Test',
  'Performance Test',
  'Test Client',
  'Test Customer',
  'QA Account',
  'System Test',
  'System User',
  'Integration Test',
  'API User',
  'Bot Account',
  'Sample Customer',
  'Sample Data',
  'Training User',
  'Practice User',
  'Demo Tester',
  'User Test',
  'Unknown User',
  'Fake Entry',
  'Bogus User',
  'Mr Fake',
  'Ms Fake',
  'Test Guy',
  'Test Girl',
  'Temporary User',
  'QA Dummy',
  'Testing Account',
  'QA Name',
  'E2E Tester',
  'Smoke Test',
  'Regression Test',
  'Test Subject',
  'QA Example',
  'Trial User',
  'QA Engineer',
  'Automation Engineer',
  'Mr Placeholder',
  'Ms Placeholder',
  'First Last',
  'Test Admin',
  'Admin Test',
  'Demo Admin',
  'Sample Admin',
  'Dev User',
  'Developer Test',
  'Dev Test',
  'QA Team',
  'Load Bot',
  'Performance Bot',
  'Stress Bot',
  'Fake Account',
  'Fake Admin',
  'Testing123',
  'Tester123',
  'Demo123',
  'Sample123',
  'QA123',
  'User Test123',
  'Generic User',
  'Fake Data',
  'Anonymous',
  'Unknown',
  'Guest',
  'Trial Account',
  'Staging Account',
  'Sandbox Account',
  'Training Account',
  'Practice Account',
  'Testing Account 1',
  'Testing Account 2',
  'Testing Account 3',
  'Test Alpha',
  'Test Beta',
  'Test Gamma',
  'Test Delta',
  'Test Omega',
  'Mr Demo',
  'Ms Demo',
  'Demo Guy',
  'Demo Girl',
  'Sample Guy',
  'Sample Girl',
  'Placeholder User',
  'Temporary Account',
  'Disposable User',
  'QA Placeholder',
  'Fake Placeholder',
  'Unit Bot',
  'System Bot',
  'Staging Bot',
  'Sandbox Bot',
  'Trial Bot',
  'Regression Bot',
  'Smoke Bot',
  'E2E Bot',
  'Testing Bot',
  'Load Account',
  'Performance Account',
  'Stress Account',
  'QA Data',
  'Test Data User',
  'Sample Data User',
  'Demo Data User',
  'Automation Data',
  'Bot Data',
  'Placeholder Account',
  'Training Bot',
  'Practice Bot',
  'Guest User',
  'Fake Login',
  'Demo Login',
  'Sample Login',
  'QA Login',
  'Testing Login',
  'Unknown Login',
  'Anonymous Login',
  'Temporary Login',
  'Disposable Login',
  'Test Case User',
  'Case Test',
  'Unit Account',
  'Automation Account',
  'Integration Account',
  'System Account',
  'Dev Account',
  'Developer Account',
  'QA Example User',
  'Fake Example',
  'Demo Example',
  'Sample Example',
  'Placeholder Example',
  'John Example',
  'Jane Example',
  'User Example',
  'Test Example',
  'Dummy Example',
  'Training Example',
  'Practice Example',
  'Trial Example',
  'Sandbox Example',
  'Staging Example',
  'System Example',
  'QA Example Account',
  'Fake QA User',
  'Demo QA User',
  'Test QA User',
  'QA Dummy User',
  'Automation QA User',
  'Regression QA User',
  'Smoke QA User',
  'E2E QA User',
  'Stress QA User',
  'Performance QA User',
  'Load QA User',
  'Mr Testy',
  'Ms Testy',
  'Fake McFakerson',
  'Sample McSampler',
  'Demo McDemoface',
  'Placeholder Placeholder',
  'QA Placeholder User',
  'Training Placeholder',
  'Practice Placeholder',
  'Trial Placeholder',
  'Testing Placeholder',
  'Mr Example',
  'Ms Example',
  'Example Example',
  'Test Example Name',
  'Fake Example Name',
  'Demo Example Name',
  'Sample Example Name',
  'QA Example Name',
];

export default forbiddenNames;
